import { getDebugRing } from '../../lib/devUtils';
import { clx } from '../../lib/utils';
import { BackButton } from '../icons/BackButton';

export const MoodLogTopBar = (props: { currentStep: number | null }) => {
  const currentStep = props.currentStep || 1;
  const showBackButton = currentStep > 1;

  return (
    <div className="w-full pb-2 text-center">
      <h1 className={clx('mb-3 mt-4 font-bold', getDebugRing('green'))}>Mood Log</h1>
      <div className={clx('relative mx-auto inline-flex space-x-5', getDebugRing('red'))}>
        {showBackButton && (
          <BackButton className="absolute left-[-2rem] top-1/2 -translate-y-1/2" />
        )}

        {/* Progress indicator for the Mood Log. */}
        {[1, 2, 3, 4, 5].map((step) => {
          const bgColor = step > currentStep ? 'bg-background-tertiary' : 'bg-background-secondary';
          return (
            <div
              key={step}
              className={clx(
                'size-7.5 flex items-center justify-center rounded-full border text-sm',
                bgColor
              )}
            >
              {step}
            </div>
          );
        })}
      </div>
    </div>
  );
};
